import { post, upload } from './request';

export async function commonUpload(params: any) {
  return upload<any>(`/file/upload`, params);
}

/**
 * @description 语言查询分类
 * @returns {Promise<RequestResult<>>} 语言查询分类
 */
export async function getLanguageMaps() {
  return post<any>('/language/getMaps');
}

/** 待办汇总项 */
export interface TodoItem {
  /** WITHDRAW_AUDIT 出款审核 / ACTIVITY_AUDIT 活动审核 / SMS_BALANCE 短信余额不足 */
  code: string;
  title: string;
  count: number;
}

/**
 * @description 右上角待办汇总；只返回当前账号有菜单权限的项，total 是这些项的合计
 */
export async function getTodoSummary() {
  return post<{ total: number; items: TodoItem[] }>('/todo/summary', {});
}
